<template>
<svg xmlns="http://www.w3.org/2000/svg" class="tw-fill-primary-light dark:tw-fill-primary-dark" viewBox="0 0 15 12"><path d="M4.88.29.59 4.59a2 2 0 0 0 0 2.82l4.29 4.3a1 1 0 1 0 1.41-1.42L3 7h11a1 1 0 1 0 0-2H3l3.29-3.29A1 1 0 1 0 4.88.29"/></svg>
</template>
